// extracted by mini-css-extract-plugin
export default {"NewsWrapper":"News_NewsWrapper__Bjgkj","news-page":"News_news-page__J2oGi","news-page__title":"News_news-page__title__2l65p"};